import { Box, Typography } from "@mui/material"

const CoreVision = () => {
    return(
        <Box sx={{ pt: {xs: 5, md: 15}, px: {xs: 4, md: 20}, textAlign: "left", gap: '20px',  }}>
            <Box sx={{mb: {xs: 2, md: 6}}}>
                <Typography variant="h3" gutterBottom sx={{ lineHeight: "60px", width:{ xs: "100%", md: "40%"}}} >
                Core Vision
                </Typography>
            </Box>
            <Box sx={{ display:{xs: "block", md: "flex"}}} gap={8} mb={4}>
                <Box sx={{flex: "1 1"}}>
                    <Box mb={4}>
                        <Typography flex='1 1' fontWeight="bold" variant="subtitle1" margin='auto'>
                        Main Goal:
                        </Typography>
                        <Typography flex='1 1' variant="subtitle1" margin='auto'>
                        "To foster sustainable rural development by producing eco-friendly biofuels and high-value byproducts that empower farmers, enhance rural livelihoods, and contribute to India’s energy security and environmental sustainability."
                        </Typography>
                    </Box>
                    <Box sx={{mb: {xs: 4, md: 0}}}>
                        <Typography flex='1 1' fontWeight="bold" variant="subtitle1" margin='auto'>
                        Motto:
                        </Typography>
                        <Typography flex='1 1' variant="subtitle1" margin='auto'>
                        "Fueling Growth, Empowering Communities, Securing the Future."
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ flex: "1 1"}}>
                    <Typography flex='1 1' fontWeight="bold" variant="subtitle1" margin='auto'>
                    Guiding Principles
                    </Typography>
                    <Typography flex='1 1' variant="subtitle1" margin='auto'>
                    Vivek Bio-Products is driven by its commitment to sustainable development. Its operations integrate economic progress with environmental stewardship and social responsibility. The company’s dual focus on renewable energy production and farmer empowerment underscores its role as a catalyst for change, addressing global challenges such as climate change and rural economic disparity. By adopting innovative practices and aligning its goals with national priorities, Vivek Bio-Products is poised to lead India toward a cleaner, greener, and more self-reliant future. The company’s mission and motto encapsulate its dedication to creating lasting value for all stakeholders while contributing to the nation’s progress and sustainability
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default CoreVision